import rowingBoat from '../assets/rowing-boat.jpg';
import Navigation from './Navigation';
const HeroSection = () => {
  return (
    <div className="section-seamless" style={{
      minHeight: '100vh',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {/* Rotated background image layer */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `url(${rowingBoat})`,
        backgroundSize: '150%',
        backgroundPosition: '22% center',
        backgroundRepeat: 'no-repeat',
        transform: 'rotate(180deg)',
        zIndex: 0
      }}></div>

      <Navigation />

      {/* Hero Text Content */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '1800px',
        padding: '0 20px'
      }}>
        {/* Desktop Layout */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          maxWidth: '100%',
          overflow: 'hidden',
          flexWrap: 'nowrap',
          marginTop: '-170px'
        }}
        className="desktop-hero">
          <h1 style={{
            fontSize: 'clamp(2rem, 3.5vw, 2.5rem)',
            fontWeight: '400',
            color: 'white',
            margin: 0,
            letterSpacing: '0.15em',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
            whiteSpace: 'nowrap'
          }}>
            THIS IS
          </h1>
          <h1 style={{
            fontSize: 'clamp(2rem, 3.5vw, 2.5rem)',
            fontWeight: '400',
            color: '#4396C6',
            margin: 0,
            letterSpacing: '0.15em',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
            whiteSpace: 'nowrap'
          }}>
            THE ULTIMATE TEST...
          </h1>
        </div>

        {/* Mobile Layout */}
        <div style={{
          display: 'none',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '0px',
          padding: '40px 20px'
        }}
        className="mobile-hero">
          {/* Top Text */}
          <h1 style={{
            fontSize: 'clamp(2rem, 8vw, 3rem)',
            fontWeight: '400',
            color: 'white',
            margin: 0,
            letterSpacing: '0.1em',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
            lineHeight: '1.2',
              marginTop: '40px'
            // paddingBottom: '10px'
          }}>
            THIS IS
          </h1>

          {/* Bottom Text */}
          <h1 style={{
            fontSize: 'clamp(2rem, 8vw, 3rem)',
            fontWeight: '400',
            color: '#4396C6',
            margin: 0,
            letterSpacing: '0.1em',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
            lineHeight: '1.2',
            paddingTop: '60px'
          }}>
            THE ULTIMATE TEST...
          </h1>
        </div>
      </div>

    </div>
  );
};

export default HeroSection;
